import React from "react";
import { ListItemButton as ListItemButtonBase, ListItemIcon, ListItemText, List } from "@mui/material";

// MUI v5 replaced `<ListItem button>` with `<ListItemButton>`. Alias it (cast to
// `any`) so the drag `ref` and other props below still type-check.
const ListItem: any = ListItemButtonBase;
import { makeStyles } from "@/compat/muiStyles";
import { Description, Image, Videocam } from "@mui/icons-material";
import { fileExtensions } from "../../constants/documentConstants";
import { useSelector } from "react-redux";
import { useDrag } from 'react-dnd';
import { documentTypes } from "../../constants/documentConstants";

const useStyles = makeStyles(() => ({
  text: {
    overflowWrap: "break-word"
  }
}))

const DocumentItem = ({ documentName, setSelectedFile, selectedFile, documentType }) => {

    const classes = useStyles();
    const { selectedFolder } = useSelector((state: any) => state.documents);

    const [, drag] = useDrag(
        () => ({
            type: 'file',
            item: () => {
                return { documentName, from: selectedFolder };
            },
            canDrag: documentType === documentTypes.ACCOUNT,
            collect: (monitor) => ({
                isDragging: monitor.isDragging(),
            }),
        }),
    )

    return (
        <ListItem
            ref={drag}
            selected={selectedFile.path === selectedFolder + "/" + documentName}
            onClick={() =>
                setSelectedFile({
                    name: documentName,
                    path: selectedFolder + "/" + documentName,
                })
            }
        >
            <ListItemIcon>
                {fileExtensions.image.reduce(
                    (prev, curr) => prev || documentName.endsWith(curr),
                    false
                ) ? (
                    <Image />
                ) : fileExtensions.video.reduce(
                    (prev, curr) => prev || documentName.endsWith(curr),
                    false
                ) ? (
                    <Videocam />
                ) : (
                    <Description />
                )}
            </ListItemIcon>
            <ListItemText primary={documentName} className={classes.text} />
        </ListItem>
    );
}

const DocumentList = ({ documentNames, setSelectedFile, selectedFile, documentType }) => {  

  return (
    <List disablePadding>
          {
              documentNames.map((documentName) => (
                  <DocumentItem
                      setSelectedFile={setSelectedFile}
                      selectedFile={selectedFile}
                      documentName={documentName}
                      key={documentName}
                      documentType={documentType}
                  />
              ))
          }
    </List>
  );
};

export default DocumentList;
